import * as React from "react";
import { forwardRef } from "react";
const SvgIconMinimize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m17.443 2.281-5.412 5.431V2.7h-1.167v7h7V8.532h-5.013l5.43-5.412zM2.7 10.864v1.166h5.012l-5.431 5.413.838.838 5.412-5.431v5.011H9.7v-7z", "data-name": "icon/minimize", transform: "translate(-2.282 -2.282)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconMinimize);
export { ForwardRef as ReactComponent };
